import type { ASTEntityType } from 'src/api/generated/touring/types';
import type { TicketSalesAstEntityType } from '../../types';

export const mapTicketSalesAstEntityType = (
  entity: ASTEntityType
): TicketSalesAstEntityType => ({
  id: entity.id,
  label: entity.label,
  color: entity.color,
});
